export default "__VITE_ASSET__EbLKF_9K__"